<div
    class="sm:absolute sm:inset-0 flex flex-col flex-auto min-w-0 sm:overflow-hidden bg-card dark:bg-transparent">

    <div class="flex flex-auto overflow-hidden">

        <div class="flex flex-col flex-auto sm:mb-18 overflow-hidden sm:overflow-y-auto">
            <ng-container>
                <ng-container *ngIf="romasters.length > 0; else noProducts">
                    <div class="grid overflow-x-auto">
                        <div class="inventory-gridz z-10 sticky top-0 grid gap-4 py-4 items-center px-6 md:px-8 shadow text-md font-semibold text-secondary bg-gray-50 dark:bg-card"
                            matSort #sort (matSortChange)="customSort($event)">
                            <div *ngFor="let head of headers;let i = index">
                                <div [class]="head.class" [mat-sort-header]="head.column">
                                    {{head.header}}
                                </div>
                            </div>
                        </div>
                        <ng-container>
                            <ng-container *ngFor="let trans of romasters;">
                                <div class="inventory-gridz grid items-center gap-4 py-3 px-6 md:px-8 border-b">
                                    <div *ngFor="let head of headers;let i = index">
                                        <div class="flex items-center">
                                            <div *ngIf="head.type === 'image'"
                                                class="relative flex flex-0 items-center justify-center w-12 h-12 mr-6 rounded overflow-hidden border">
                                                <img class="w-8" *ngIf="trans[head.column]"
                                                    [alt]="'transaction thumbnail image'" [src]="trans[head.column]">
                                                <div class="flex items-center justify-center w-full h-full text-xs font-semibold leading-none text-center uppercase"
                                                    *ngIf="!trans[head.column]">
                                                    NO THUMB
                                                </div>
                                            </div>
                                        </div>

                                        <div *ngIf="head.type == 'text'" [class]="head.classtab">
                                            {{getProperty(trans, head.column)}}
                                        </div>
                                       
                                    </div>
                                </div>
                                <div class="grid">
                                    <ng-container *ngIf="selectedlog?._id === trans._id">
                                        <ng-container
                                            *ngTemplateOutlet="rowDetailsTemplate; context: {$implicit: trans}"></ng-container>
                                    </ng-container>
                                </div>
                            </ng-container>
                        </ng-container>
                    </div>

                </ng-container>
            </ng-container>

            <ng-template #noProducts>
                <div *ngIf="!loadingapi" class="p-8 sm:p-16 border-t text-4xl font-semibold tracking-tight text-center">
                    No ROs found!</div>
            </ng-template>
        </div>
    </div>
</div>